import { AnyAction } from "@reduxjs/toolkit";
// import { event } from "../actions/authActions";

interface AuthState {
  events:any[]
}

const initialState: AuthState = {
  events:[]
};

// type AuthAction = ReturnType<typeof event>;

const authReducer = (state: AuthState = initialState, action: AnyAction): AuthState => {
  switch (action.type) {
    case 'EVENT_ADD':
      return {
        ...state,
        events: action.payload.data,
      };
    
   
    default:
      return state;
  }
};

export default authReducer;
